/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DetailGridSkeleton from './skeleton/DetailGridSkeleton';
import Table from './Table';
import moment from 'moment';
import useDate from '../../../utils/useDate';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const Transaction = ({
  dataFetching,
  claimDetailsResp,
  gridColumnsDisplay,
  overlay,
}) => {
  const { formatDate } = useDate();
  //const isSuppressPaymentInfo = claimDetailsResp?.Claim?.SuppressPaymentInfo === 'true';
  const isSuppressPaymentInfo =
    claimDetailsResp?.Claim?.DisplayPaymentInfo !== 'true';
  const ClaimDetailsRec = {};
  ClaimDetailsRec.data = [];
  ClaimDetailsRec.columns = [];
  if (gridColumnsDisplay?.Service_Date) {
    ClaimDetailsRec.columns.push({
      Header: 'Service Date',
      accessor: 'ServiceDate',
      width: !isSuppressPaymentInfo ? 70 : 150,
      Footer: 'Total',
      sortType: (a, b) => {
        const a1 = new Date(a).getDate();
        const b1 = new Date(b).getDate();
        if (a1 < b1) return 1;
        else if (a1 > b1) return -1;
        else return 0;
      },
    });
  }
  if (gridColumnsDisplay?.Service_Code) {
    ClaimDetailsRec.columns.push({
      Header: 'Service Code',
      accessor: 'Service',
      width: !isSuppressPaymentInfo ? 60 : 800,
      //footer: Service => Service.reduce((acc, item) => acc + item, 0)
      Footer: '',
    });
  }
  if (gridColumnsDisplay?.Charge) {
    ClaimDetailsRec.columns.push({
      Header: 'Charges',
      accessor: 'Charge',
      sortType: 'basic',
      width: !isSuppressPaymentInfo ? 60 : 120,
      Footer: formatter.format(claimDetailsResp?.Claim?.TotalCharge),
    });
  }

  if (!isSuppressPaymentInfo) {
    if (gridColumnsDisplay?.Benefit_Code) {
      ClaimDetailsRec.columns.push({
        Header: 'Benefit Code',
        accessor: 'BenifitCode',
        width: !isSuppressPaymentInfo ? 65 : 800,
        Footer: '',
      });
    }
    if (gridColumnsDisplay?.Unit) {
      ClaimDetailsRec.columns.push({
        Header: 'Unit',
        accessor: 'Unit',
        width: !isSuppressPaymentInfo ? 60 : 800,
        Footer: '',
      });
    }
    if (gridColumnsDisplay?.Reason) {
      ClaimDetailsRec.columns.push({
        Header: 'Reason',
        accessor: 'Reason',
        width: !isSuppressPaymentInfo ? 60 : 800,
        Footer: '',
      });
    }
    if (gridColumnsDisplay?.Discount) {
      ClaimDetailsRec.columns.push({
        Header: 'Discount',
        accessor: 'Discount',
        sortType: 'basic',
        width: 70,
        Footer: isSuppressPaymentInfo
          ? '---'
          : formatter.format(claimDetailsResp?.Claim?.TotProvDisc),
      });
    }

    if (gridColumnsDisplay?.Covered) {
      ClaimDetailsRec.columns.push({
        Header: 'Covered',
        accessor: 'Covered',
        sortType: 'basic',
        width: 55,
        Footer: isSuppressPaymentInfo
          ? '---'
          : claimDetailsResp?.Claim?.TotalCovered != undefined
          ? formatter.format(claimDetailsResp?.Claim?.TotalCovered)
          : formatter.format(0),
      });
    }

    if (gridColumnsDisplay?.Deductible) {
      ClaimDetailsRec.columns.push({
        Header: 'Deductible',
        accessor: 'Deductible',
        sortType: 'basic',
        width: 60,
        Footer: isSuppressPaymentInfo
          ? '---'
          : formatter.format(claimDetailsResp?.Claim?.TotDeduct),
      });
    }
    if (gridColumnsDisplay?.Payment_Amount) {
      ClaimDetailsRec.columns.push({
        Header: 'Payment Amount',
        accessor: 'PaymentAmount',
        sortType: 'basic',
        width: 90,
        Footer: isSuppressPaymentInfo
          ? '---'
          : formatter.format(claimDetailsResp?.Claim?.TotalPaid),
      });
    }

    if (gridColumnsDisplay?.Modifier) {
      ClaimDetailsRec.columns.push({
        Header: 'Modifier',
        accessor: 'Modifier',
        sortType: 'basic',
        width: 60,
        Footer: '',
      });
    }
    if (gridColumnsDisplay?.Not_Paid) {
      ClaimDetailsRec.columns.push({
        Header: 'Not Paid',
        accessor: 'NotPaid',
        sortType: 'basic',
        width: 60,
        Footer: '',
      });
    }
    if (gridColumnsDisplay?.CoinsuranceAmount) {
      ClaimDetailsRec.columns.push({
        Header: 'Coinsurance$',
        accessor: 'CoinsuranceAmount',
        sortType: 'basic',
        width: 75,
        Footer: isSuppressPaymentInfo
          ? '---'
          : formatter.format(claimDetailsResp?.Claim?.TotCoins),
      });
    }
    if (gridColumnsDisplay?.CoinsurancePercentage) {
      ClaimDetailsRec.columns.push({
        Header: 'Coinsurance%',
        accessor: 'CoinsurancePercentage',
        sortType: 'basic',
        width: 75,
        Footer: '',
      });
    }
    if (gridColumnsDisplay?.Service_Qualifier) {
      ClaimDetailsRec.columns.push({
        Header: 'Service Qualifier',
        accessor: 'ServiceQualifier',
        sortType: 'basic',
        width: 85,
        Footer: '',
      });
    }
  }
  /*************/
  const claimsData = claimDetailsResp?.Claim?.ServiceLine.map((key, value) => {
    if (key.Claimnumber) {
      const ServiceDateInfo = gridColumnsDisplay?.Service_Date
        ? {
            ServiceDate:
              formatDate(key?.FromDate) + '_' + formatDate(key?.ThroughDate),
          }
        : '';
      const ServiceCodeInfo = gridColumnsDisplay?.Service_Code
        ? {
            Service: `${key.RevenueCode ? key.RevenueCode : ''}/${
              key.ProcedureCode ? key.ProcedureCode : ''
            }`,
          }
        : '';
      const ChargeInfo = gridColumnsDisplay?.Charge
        ? { Charge: key?.Charge ? key?.Charge : -1 }
        : '';
      const DiscAmtInfo = gridColumnsDisplay?.Discount
        ? { Discount: key?.DiscAmt ? key?.DiscAmt : -1 }
        : '';
      const CoveredInfo = gridColumnsDisplay?.Covered
        ? { Covered: key?.Covered ? key?.Covered : -1 }
        : '';
      const DeductibleInfo = gridColumnsDisplay?.Deductible
        ? { Deductible: key?.DeductibleAmt ? key?.DeductibleAmt : -1 }
        : '';
      const CoinsuranceAmountInfo = gridColumnsDisplay?.CoinsuranceAmount
        ? { CoinsuranceAmount: key?.CoinsAmt ? key?.CoinsAmt : -1 }
        : '';
      const CoinsurancePercentInfo = gridColumnsDisplay?.CoinsurancePercentage
        ? {
            CoinsurancePercentage: key.Coinsurance_Percentage,
          }
        : '';
      const UnitInfo = gridColumnsDisplay?.Unit ? { Unit: key.Unit } : '';
      const NotPaidInfo = gridColumnsDisplay?.Not_Paid
        ? { NotPaid: key?.Not_Paid ? key?.Not_Paid : -1 }
        : '';
      const PaymentAmountInfo = gridColumnsDisplay?.Payment_Amount
        ? { PaymentAmount: key?.PaymentAmt ? key?.PaymentAmt : -1 }
        : '';
      const BenifitCodeInfo = gridColumnsDisplay?.Benefit_Code
        ? { BenifitCode: key?.BenifitCode ? key?.BenifitCode : -1 }
        : '';
      const ReasonInfo = gridColumnsDisplay?.Reason
        ? { Reason: key.InEligibleRsnCode }
        : '';
      const ModifierInfo = gridColumnsDisplay?.Modifier
        ? { Modifier: key.Modifier ? key.Modifier : 'NA' }
        : '';
      const ServiceQualifierInfo = gridColumnsDisplay?.Service_Qualifier
        ? { ServiceQualifier: 'NA' }
        : '';
      if (!isSuppressPaymentInfo) {
        ClaimDetailsRec.data.push({
          ...ServiceDateInfo,
          ...ServiceCodeInfo,
          ...ChargeInfo,
          ...DiscAmtInfo,
          ...CoveredInfo,
          ...PaymentAmountInfo,
          ...DeductibleInfo,
          ...CoinsurancePercentInfo,
          ...CoinsuranceAmountInfo,
          ...UnitInfo,
          ...NotPaidInfo,
          ...BenifitCodeInfo,
          ...ReasonInfo,
          ...ModifierInfo,
          ...ServiceQualifierInfo,
        });
      } else {
        ClaimDetailsRec.data.push({
          ...ServiceDateInfo,
          ...ServiceCodeInfo,
          ...ChargeInfo,
        });
      }
    }
  });

  //Render the UI for your table
  return (
    <div className="">
      {dataFetching ? (
        <DetailGridSkeleton />
      ) : (
        <>
          <Row className="mt-2">
            <Col>
              <div>
                <h3 className="claim-details-service">
                  Services for this Claim
                </h3>
              </div>
            </Col>
          </Row>
          <Row className="datatable-claims-details custom-details">
            <Col>
              <Table
                columns={ClaimDetailsRec.columns}
                data={ClaimDetailsRec.data}
                isSuppressPaymentInfo={isSuppressPaymentInfo}
                overlay={overlay}
              ></Table>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default Transaction;
